

export default function INIT() {

  // DOM Ready
  $(() => {


    //PC スクールにサブメニュー追加
    const $subMenuPc = $(`
    <ul class="subMenu">
      <li class="subMenu-item"><a href="/school/?mode=detail&article=2" class="ui-link-inherit">タイムテーブル</a></li>
      <li class="subMenu-item"><a href="/school/?mode=detail&article=1" class="ui-link-inherit">料金表</a></li>
      <li class="subMenu-item"><a href="/school/?mode=detail&article=3" class="ui-link-inherit">コーチ紹介</a></li>
    </ul>`)

    $('#gmenu ul li a.mschool').after($subMenuPc)


    //SP スクールにサブメニュー追加
    const $subMenuSp = $(`
    <li data-theme="c" class="ui-btn ui-btn-up-c ui-btn-icon-right ui-li-has-arrow ui-li is-submenu">
     <div class="ui-btn-inner ui-li" aria-hidden="true">
      <div class="ui-btn-text">
        <a href="/school/?mode=detail&article=2" class="ui-link-inherit">
          タイムテーブル
         </a>
       </div>
       <span class="ui-icon ui-icon-arrow-r ui-icon-shadow"></span>
      </div>
    </li>
    <li data-theme="c" class="ui-btn ui-btn-up-c ui-btn-icon-right ui-li-has-arrow ui-li is-submenu">
      <div class="ui-btn-inner ui-li" aria-hidden="true">
        <div class="ui-btn-text">
          <a href="/school/?mode=detail&article=1" class="ui-link-inherit">
            料金表
          </a>
        </div>
        <span class="ui-icon ui-icon-arrow-r ui-icon-shadow"></span>
      </div>
    </li>
    <li data-theme="c" class="ui-btn ui-btn-up-c ui-btn-icon-right ui-li-has-arrow ui-li is-submenu">
     <div class="ui-btn-inner ui-li" aria-hidden="true">
      <div class="ui-btn-text">
        <a href="/school/?mode=detail&article=3" class="ui-link-inherit">
        コーチ紹介
         </a>
       </div>
       <span class="ui-icon ui-icon-arrow-r ui-icon-shadow"></span>
      </div>
    </li>
    `)

    $('ul.ui-listview .ui-li:nth-child(2)').after($subMenuSp)

  })

}